import React from 'react';
import FilterListIcon from '@material-ui/icons/FilterList';
import {
  Box,
  makeStyles,
  Grid,
  Chip,
  Typography,
} from '@material-ui/core';
import cx from 'classnames';
import { useSelector } from 'react-redux';
import { FAKE_TITLE_DATA } from '../../FakeDataGenerator';

const useStyles = makeStyles((theme) => ({
  title: {
    position: 'relative',
    marginLeft: 4,
    fontWeight: 500,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontSize: 36,
  },
  titleSmallText: {
    fontSize: 22,
  },
  titleTextBox: {
    maxHeight: 35,
    display: 'flex',
    alignItems: 'center',
  },
  titleCount: {
    position: 'relative',
    marginLeft: 4,
    fontWeight: 500,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    height: 24,
    fontSize: 11,
    color: theme.palette.common.white,
    backgroundColor: theme.colors.lightBlue,
  },
  additionChip: {
    backgroundColor: theme.colors.green,
  },
  countFiltered: {
    backgroundColor: theme.colors.blue,
  },
  filterIcon: {
    height: 15,
    width: 15,
    marginRight: 3,
    color: theme.palette.common.white,
  },
  titleCountLabel: {
    padding: theme.spacing(0, 1),
    lineHeight: 1,
    fontSize: 12,
  },
  hideCount: {
    visibility: 'hidden',
    opacity: 0,
    transition: 'visibility 0s, opacity 0.5s linear',
  },
  count: {
    visibility: 'visible',
    opacity: 1,
    transition: 'visibility 0s, opacity 0.5s linear',
  },
}));

const TableTitle = ({
                      titleText,
                      count,
                      // additionChip,
                      countFiltered,
                      smallStyle = false,
                    }) => {
  const classes = useStyles();
  // const { en: { tables } } = useSelector((state) => state.i18n);

  return <Grid container justify='flex-start' alignItems='center' style={{ flexWrap: 'nowrap' }}>
    {titleText && titleText !== FAKE_TITLE_DATA && (
      <Typography
        noWrap
        className={cx(classes.title, {
          [classes.titleSmallText]: smallStyle,
        })}
      >
        {titleText}
      </Typography>
    )}
    {count !== undefined && count !== null && (
      <Grid item className={cx(classes.hideCount, {
        [classes.count]: count !== FAKE_TITLE_DATA,
      })}
      >
        <Chip
          label={<Box display='flex' alignItems='center' fontSize={12}>
            {countFiltered ? <FilterListIcon className={classes.filterIcon} /> : <></>}
            {count.toLocaleString('en-US')}
          </Box>}
          classes={{
            root: cx(classes.titleCount, {
              [classes.countFiltered]: !!countFiltered,
            }),
            label: classes.titleCountLabel,
          }}
        />
      </Grid>
    )}
    {/*{(!!additionChip || additionChip === 0) && (*/}
    {/*  <Grid item className={cx(classes.hideCount, {*/}
    {/*    [classes.count]: additionChip !== FAKE_TITLE_DATA,*/}
    {/*  })}>*/}
    {/*    <Chip*/}
    {/*      label={`${additionChip} ${tables.completionRate}`}*/}
    {/*      classes={{*/}
    {/*        root: cx(classes.titleCount, {*/}
    {/*          [classes.additionChip]: !!additionChip,*/}
    {/*        }),*/}
    {/*        label: classes.titleCountLabel,*/}
    {/*      }}*/}
    {/*    />*/}
    {/*  </Grid>*/}
    {/*)}*/}
  </Grid>;
};

export default TableTitle;
